import React, { useEffect, useRef, useState } from "react";
import Styles from "./BannerMob.module.scss";
import classnames from "classnames";

import A from "@vahak/core/dist/components/app-anchor/A";
import ArrowDownWhite from "../../../../assets/icons/arrowDownWhite.svg";

import { scroller } from "react-scroll";
import AppImg from "components/utils/AppImg";
import { getTransporterFigure } from "@vahak/core/dist/methods/getTransporterFigure";

const BannerMob = () => {
    const scrollToSection = () => {
        scroller.scrollTo("scrollToOurstory", {
            duration: 1000,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };

    const [height, setHeight] = useState(0);
    const storyTextRef = useRef<any>(null!);

    useEffect(() => {
        if (storyTextRef.current) {
            const storyHeight = storyTextRef.current.clientHeight;
            setHeight(storyHeight);
        }
    }, [storyTextRef, height]);

    return (
        <>
            <section className={Styles.bannerSection}>
                <div className="container">
                    <div className={Styles.bannerRow}>
                        <div className={Styles.textCol}>
                            <div className={Styles.text}>
                                <h1>
                                    Building India’s Leading <span>B2B Road Transportation Marketplace</span>
                                </h1>
                                <A
                                    className={Styles.meetUsBtn}
                                    onClick={scrollToSection}
                                    style={{
                                        backgroundColor: "#1053FF",
                                        color: "#fff",
                                        textAlign: "center",
                                        fontSize: "14px",
                                        padding: "10px",
                                        height: "46px",
                                        width: "130px",
                                        display: "block",
                                        marginTop: "20px",
                                        lineHeight: "28px",
                                        fontWeight: "bold",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <span>
                                        Meet Us{" "}
                                        <ArrowDownWhite
                                            style={{
                                                width: "14px",
                                                height: "14px",
                                                position: "relative",
                                                top: "-1px",
                                                right: "-7px",
                                                transform: "rotate(90deg)"
                                            }}
                                        />
                                    </span>
                                </A>
                            </div>
                        </div>
                        <div className={Styles.aboutStoryCol}>
                            <AppImg
                                className={Styles.imgBgBox}
                                src={`ourStoryDefault.png`}
                                objectFit="cover"
                                objectPosition="center"
                                alt="our story"
                                layout="responsive"
                                width="379"
                                height="215"
                                priority
                            />
                        </div>
                    </div>
                </div>
                <div className="scrollToOurstory" style={{ paddingTop: "50px" }}></div>
                <div className={Styles.ourStoryWrapper}>
                    <div
                        className={Styles.ourStoryOuter}
                        style={{
                            height: `${height}px`
                        }}
                    >
                        <div
                            className={Styles.ourStoryImg}
                            style={{
                                filter: "blur(30px)",
                                height: "100%"
                            }}
                        >
                            <AppImg
                                className={classnames(Styles.ourStory)}
                                src={"ourStoryDefault.png"}
                                layout="fill"
                                objectFit="cover"
                                objectPosition="center"
                                // width="379"
                                // height="215"
                                // style={{
                                //     backgroundImage: `url('${IMG_BASE_URL}/379/ourStoryDefault-Mobile.png')`,
                                //     filter: "blur(12px)",
                                //     height: `${height}px`
                                // }}
                            ></AppImg>
                        </div>
                        <div ref={storyTextRef} className={Styles.ourStoryText}>
                            <div className="container">
                                <h2>Our Story</h2>
                                <p>
                                    &quot;The story begins with Karan, one of our co-founders, noticing a huge problem
                                    in India’s logistics space – SMEs were struggling to transport their product! To
                                    resolve this problem and provide logistics companies with the kind of support they
                                    needed to flourish, Karan joined with Vikas, our second-cofounder, to create Epictus
                                    Solutions. This venture helped logistics businesses with GPS and transportation
                                    solutions. With Epictus’ rapid growth, the co-founders came to a realization that
                                    Indian transporters needed more than what their venture offered – they needed an
                                    extensive platform that would let them digitize all their day-to-day business
                                    operations!
                                </p>
                                <p>
                                    And so, after trials, errors and lots of learning – Vahak was born. Today, Vahak is
                                    the largest online transport marketplace community with over{" "}
                                    {getTransporterFigure()} Indian transporters on it&apos;s platform. In the Indian
                                    logistics space, we aim to be more than just a product – we want to revolutionize
                                    the way B2B transportation happens in India!
                                </p>
                                <p>
                                    With the Vahak app, users should no longer struggle to get or provide logistics
                                    services. Logistics is the backbone of the Indian economy, and we&apos;re here to
                                    strengthen it! By providing users with the technology for booking trucks and loads
                                    online, we&apos;re bridging the gap between lorry and load businesses, and helping
                                    them serve customers better.&quot;
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default BannerMob;
